import NextLink from 'next/link';
import React from 'react';
import styled from 'styled-components';

const OutlineButton = styled.button.attrs((props) => ({
  as: buttonElement(props.href),
  ...props,
}))`
  display: inline-block;

  background: none;
  border: 1px solid rgba(19, 2, 40, 0.8);
  border-radius: 5px;
  padding: 8px 18px;
  white-space: nowrap;

  color: rgba(19, 2, 40, 0.8);

  :hover {
    text-decoration: none;
    color: rgba(19, 2, 40, 0.8);
  }
`;

const Link = styled(({ href, path, children, external, ...props }) => {
  if (external) {
    return (
      <Anchor href={href} {...props}>
        {children}
      </Anchor>
    );
  }

  return (
    <NextLink href={href} as={path} passHref>
      <Anchor {...props}>{children}</Anchor>
    </NextLink>
  );
})``;

const Anchor = styled.a``;

function buttonElement(href) {
  if (href && isUrl(href)) {
    return 'a';
  }
  if (href) {
    return Link;
  }
  return 'button';
}

function isUrl(value) {
  if (!value) {
    return false;
  }

  return value.startsWith('http');
}

export default OutlineButton;
